/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Dashboard - API
 * This API provides access and control function for smart equipped homes. For near real-time information please use this API here https://sse-hems-dev2.eon.ooo/docs/. `[NOTE]` The access token for the current user session is also valid for the real-time API utilising SSE (Server Sent Event)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  ElectricCarHistorySessionV2CalculatedResponseModel,
  ElectricCarHistoryV2ResponseModel,
  EnergyHistoryConsumptionResponseModel,
  EnergyHistoryV2ResponseModel,
  Forbidden,
  GasHistoryV2ResponseModel,
  HistoricalDeviceConsumptionResponseModel,
  NotFound,
  PowerHistoryV2ResponseModel,
  PreconditionFailed,
  PvBatteryDonutHistoryV2ResponseModel,
  SolarCloudHistoryV2ResponseModel,
  Unauthorized,
  WallboxHistorySessionV2CalculatedResponseModel,
  WallboxHistoryV2ResponseModel,
} from '../models';

export interface HistoricalDataGetConsumptionHistoryAggregatedRequest {
    deviceType: string;
    fromDate: string;
    toDate: string;
    interval?: string;
    comparisonInterval?: string;
    comparisonIteration?: number;
}

export interface HistoricalDataGetElectricCarHistorySessionsV2Request {
    fromDate: string;
    toDate: string;
}

export interface HistoricalDataGetElectricCarHistoryV2Request {
    fromDate: string;
    toDate: string;
    interval?: string;
    comparisonInterval?: string;
    comparisonIteration?: number;
}

export interface HistoricalDataGetEnergyAggregatedV2Request {
    fromDate: string;
    toDate: string;
    interval?: string;
    comparisonInterval?: string;
    comparisonIteration?: number;
}

export interface HistoricalDataGetGasAggregatedV2Request {
    fromDate: string;
    toDate: string;
    interval?: string;
    comparisonInterval?: string;
    comparisonIteration?: number;
}

export interface HistoricalDataGetHistoryDonutAggregatedV2Request {
    toDate?: string;
    periods?: Array<string>;
}

export interface HistoricalDataGetPowerAggregatedV2Request {
    fromDate: string;
    toDate: string;
    interval?: string;
    comparisonInterval?: string;
    comparisonIteration?: number;
}

export interface HistoricalDataGetSolarCloudBalanceHistoryV2Request {
    fromDate: string;
    toDate: string;
    interval?: string;
}

export interface HistoricalDataGetWallboxHistorySessionsV2Request {
    fromDate: string;
    toDate: string;
}

export interface HistoricalDataGetWallboxHistoryV2Request {
    fromDate: string;
    toDate: string;
    interval?: string;
    comparisonInterval?: string;
    comparisonIteration?: number;
}

/**
 * 
 */
export class HistoricalDataApi extends runtime.BaseAPI {

    /**
     * Get consumption history aggregated data for a specific device type
     * Get history graph data v2
     */
    async historicalDataGetConsumptionHistoryAggregatedRaw(requestParameters: HistoricalDataGetConsumptionHistoryAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EnergyHistoryConsumptionResponseModel>>> {
        if (requestParameters.deviceType === null || requestParameters.deviceType === undefined) {
            throw new runtime.RequiredError('deviceType','Required parameter requestParameters.deviceType was null or undefined when calling historicalDataGetConsumptionHistoryAggregated.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetConsumptionHistoryAggregated.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetConsumptionHistoryAggregated.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.comparisonInterval !== undefined) {
            queryParameters['comparisonInterval'] = requestParameters.comparisonInterval;
        }

        if (requestParameters.comparisonIteration !== undefined) {
            queryParameters['comparisonIteration'] = requestParameters.comparisonIteration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/consumption/{deviceType}`.replace(`{${"deviceType"}}`, encodeURIComponent(String(requestParameters.deviceType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get consumption history aggregated data for a specific device type
     * Get history graph data v2
     */
    async historicalDataGetConsumptionHistoryAggregated(requestParameters: HistoricalDataGetConsumptionHistoryAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EnergyHistoryConsumptionResponseModel>> {
        const response = await this.historicalDataGetConsumptionHistoryAggregatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get historical consumption data for all connected devices
     * Retrieve historical devices consumption data
     */
    async historicalDataGetDevicesConsumptionHistoryAggregatedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoricalDeviceConsumptionResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/heatpump:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/devices-consumption`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get historical consumption data for all connected devices
     * Retrieve historical devices consumption data
     */
    async historicalDataGetDevicesConsumptionHistoryAggregated(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoricalDeviceConsumptionResponseModel> {
        const response = await this.historicalDataGetDevicesConsumptionHistoryAggregatedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get electric car charging history data grouped by charging sessions
     * Get history data grouped by sessions
     */
    async historicalDataGetElectricCarHistorySessionsV2Raw(requestParameters: HistoricalDataGetElectricCarHistorySessionsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ElectricCarHistorySessionV2CalculatedResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetElectricCarHistorySessionsV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetElectricCarHistorySessionsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/electric-car/sessions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get electric car charging history data grouped by charging sessions
     * Get history data grouped by sessions
     */
    async historicalDataGetElectricCarHistorySessionsV2(requestParameters: HistoricalDataGetElectricCarHistorySessionsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ElectricCarHistorySessionV2CalculatedResponseModel>> {
        const response = await this.historicalDataGetElectricCarHistorySessionsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get electric car charging history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetElectricCarHistoryV2Raw(requestParameters: HistoricalDataGetElectricCarHistoryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ElectricCarHistoryV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetElectricCarHistoryV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetElectricCarHistoryV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.comparisonInterval !== undefined) {
            queryParameters['comparisonInterval'] = requestParameters.comparisonInterval;
        }

        if (requestParameters.comparisonIteration !== undefined) {
            queryParameters['comparisonIteration'] = requestParameters.comparisonIteration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/electric-car`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get electric car charging history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetElectricCarHistoryV2(requestParameters: HistoricalDataGetElectricCarHistoryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ElectricCarHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetElectricCarHistoryV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get energy history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetEnergyAggregatedV2Raw(requestParameters: HistoricalDataGetEnergyAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EnergyHistoryV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetEnergyAggregatedV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetEnergyAggregatedV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.comparisonInterval !== undefined) {
            queryParameters['comparisonInterval'] = requestParameters.comparisonInterval;
        }

        if (requestParameters.comparisonIteration !== undefined) {
            queryParameters['comparisonIteration'] = requestParameters.comparisonIteration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/energy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get energy history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetEnergyAggregatedV2(requestParameters: HistoricalDataGetEnergyAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EnergyHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetEnergyAggregatedV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get gas consumption history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetGasAggregatedV2Raw(requestParameters: HistoricalDataGetGasAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GasHistoryV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetGasAggregatedV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetGasAggregatedV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.comparisonInterval !== undefined) {
            queryParameters['comparisonInterval'] = requestParameters.comparisonInterval;
        }

        if (requestParameters.comparisonIteration !== undefined) {
            queryParameters['comparisonIteration'] = requestParameters.comparisonIteration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/gas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get gas consumption history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetGasAggregatedV2(requestParameters: HistoricalDataGetGasAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GasHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetGasAggregatedV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get donut chart data for energy usage visualization
     * Get Donut graph data v2
     */
    async historicalDataGetHistoryDonutAggregatedV2Raw(requestParameters: HistoricalDataGetHistoryDonutAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PvBatteryDonutHistoryV2ResponseModel>>> {
        const queryParameters: any = {};

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.periods) {
            queryParameters['periods'] = requestParameters.periods;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/donut`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get donut chart data for energy usage visualization
     * Get Donut graph data v2
     */
    async historicalDataGetHistoryDonutAggregatedV2(requestParameters: HistoricalDataGetHistoryDonutAggregatedV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PvBatteryDonutHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetHistoryDonutAggregatedV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the latest electric car charging session data with price calculations
     * Get last session history data with price actual and max cost calculations
     */
    async historicalDataGetLatestElectricCarHistorySessionsV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ElectricCarHistorySessionV2CalculatedResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/electric-car/sessions/latest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the latest electric car charging session data with price calculations
     * Get last session history data with price actual and max cost calculations
     */
    async historicalDataGetLatestElectricCarHistorySessionsV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ElectricCarHistorySessionV2CalculatedResponseModel> {
        const response = await this.historicalDataGetLatestElectricCarHistorySessionsV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Get the latest wallbox charging session data with price calculations
     * Get last session history data with price actual and max cost calculations
     */
    async historicalDataGetLatestWallboxHistorySessionsV2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WallboxHistorySessionV2CalculatedResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/ev:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/wallbox/sessions/latest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the latest wallbox charging session data with price calculations
     * Get last session history data with price actual and max cost calculations
     */
    async historicalDataGetLatestWallboxHistorySessionsV2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WallboxHistorySessionV2CalculatedResponseModel> {
        const response = await this.historicalDataGetLatestWallboxHistorySessionsV2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Get power history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetPowerAggregatedV2Raw(requestParameters: HistoricalDataGetPowerAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PowerHistoryV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetPowerAggregatedV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetPowerAggregatedV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.comparisonInterval !== undefined) {
            queryParameters['comparisonInterval'] = requestParameters.comparisonInterval;
        }

        if (requestParameters.comparisonIteration !== undefined) {
            queryParameters['comparisonIteration'] = requestParameters.comparisonIteration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/power`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get power history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetPowerAggregatedV2(requestParameters: HistoricalDataGetPowerAggregatedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PowerHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetPowerAggregatedV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get solar cloud balance history aggregated data
     * Get solarcloud history graph data v2
     */
    async historicalDataGetSolarCloudBalanceHistoryV2Raw(requestParameters: HistoricalDataGetSolarCloudBalanceHistoryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SolarCloudHistoryV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetSolarCloudBalanceHistoryV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetSolarCloudBalanceHistoryV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/pvb:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/solarcloud`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get solar cloud balance history aggregated data
     * Get solarcloud history graph data v2
     */
    async historicalDataGetSolarCloudBalanceHistoryV2(requestParameters: HistoricalDataGetSolarCloudBalanceHistoryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SolarCloudHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetSolarCloudBalanceHistoryV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get wallbox charging history data grouped by charging sessions
     * Get history data grouped by sessions
     */
    async historicalDataGetWallboxHistorySessionsV2Raw(requestParameters: HistoricalDataGetWallboxHistorySessionsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WallboxHistorySessionV2CalculatedResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetWallboxHistorySessionsV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetWallboxHistorySessionsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/ev:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/wallbox/sessions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get wallbox charging history data grouped by charging sessions
     * Get history data grouped by sessions
     */
    async historicalDataGetWallboxHistorySessionsV2(requestParameters: HistoricalDataGetWallboxHistorySessionsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WallboxHistorySessionV2CalculatedResponseModel>> {
        const response = await this.historicalDataGetWallboxHistorySessionsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get wallbox charging history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetWallboxHistoryV2Raw(requestParameters: HistoricalDataGetWallboxHistoryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WallboxHistoryV2ResponseModel>>> {
        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling historicalDataGetWallboxHistoryV2.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling historicalDataGetWallboxHistoryV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = requestParameters.toDate;
        }

        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }

        if (requestParameters.comparisonInterval !== undefined) {
            queryParameters['comparisonInterval'] = requestParameters.comparisonInterval;
        }

        if (requestParameters.comparisonIteration !== undefined) {
            queryParameters['comparisonIteration'] = requestParameters.comparisonIteration;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/energydevices/ev:read"]);
        }

        const response = await this.request({
            path: `/api/v2/historical-data/wallbox`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get wallbox charging history aggregated data with comparison intervals
     * Get history graph data v2
     */
    async historicalDataGetWallboxHistoryV2(requestParameters: HistoricalDataGetWallboxHistoryV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WallboxHistoryV2ResponseModel>> {
        const response = await this.historicalDataGetWallboxHistoryV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
